import { Pill, styled } from '@/theme/index';

export const MatchTag = styled(Pill)(({ theme }) => ({
  padding: `${theme.spacing(1.75)} ${theme.spacing(0.5)}`,
  backgroundColor: theme.palette.secondary.main,
  borderRadius: theme.spacing(0.5),
  '.MuiChip-label, .MuiChip-icon': {
    color: theme.palette.primary.main,
  },
  '.MuiChip-icon': {
    marginRight: theme.spacing(0.1),
  },
}));
